import { AuthUserEffects } from '../../../../../effects/authUserEffects';
import { Navigator } from '../../../../../effects/navigator';
import { ContentLibSelectors } from '../../../../../store/contentLib/selectors';
import { EContentLibViewMode } from '../../../../../store/contentLib/types';
import { getMainViewMode } from '../../../../../store/general/selectors';
import { EMainViewMode } from '../../../../../store/general/types';
import { AppThunk } from '../../../../../store/types';
import { ContentLibEvents } from '../../../ContentLibrary/effects';

export class LangMenuListEvents {

	public static onChange (langCode: string): AppThunk {
		return (
			dispatch,
			getState
		) => {
			AuthUserEffects.setLang(langCode);

			if (getMainViewMode(getState()) === EMainViewMode.CONTENT_LIBRARY) {
				const groupId = ContentLibSelectors.getSelectedGroupId(getState());
				if (groupId) {
					dispatch(ContentLibEvents.closeGroup(groupId, EContentLibViewMode.GROUP_LIST));
				}
				Navigator.navigateContentLib({langCode});
			}
		}
	}

}